
<template>
  <div id="chart3"
       style="width:100%; height: 100%;"></div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ['width', "height", 'data'],
  // data:{name:'标题',  data: [
  //           { value: 335, name: '直接访问' },
  //           { value: 310, name: '邮件营销' },
  //           { value: 234, name: '联盟广告' },
  //           { value: 135, name: '视频广告' },
  //           { value: 1548, name: '搜索引擎' }
  //         ]}
  watch: {
    data: {
      handler: function () {
        this.init()
      },
      deep: true    }
  },
  data () {
    return {
      legendData: [],
      // data: [
      //   { value: 335, name: '直接访问' },
      //   { value: 310, name: '邮件营销' },
      //   { value: 274, name: '联盟广告' },
      //   { value: 235, name: '视频广告' },
      //   { value: 400, name: '搜索引擎' }
      // ]
    }
  },
  mounted () {
    this.getLegend()
    this.init()
  },
  methods: {
    getLegend () {
      let data = this.data
      let legendData = []
      data.forEach(item => {
        legendData.push(item.name)
        this.legendData = legendData
      })
    },
    init () {


      let option = {
        backgroundColor: 'transparent',

        title: {
          text: '',
          left: 'center',
          top: 20,
          textStyle: {
            color: '#ccc'
          }
        },

        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        visualMap: {
          show: false,
          min: 0,
          max: 0,
          inRange: {
            colorLightness: [0, 1]
          }
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            // data: [
            //   { value: 335, name: '直接访问' },
            //   { value: 310, name: '邮件营销' },
            //   { value: 274, name: '联盟广告' },
            //   { value: 235, name: '视频广告' },
            //   { value: 400, name: '搜索引擎' }
            // ].sort(function (a, b) { return a.value - b.value; }),
            data: this.data,
            roseType: 'radius',
            label: {
              normal: {
                textStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                }
              }
            },
            labelLine: {
              normal: {

                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            },
            itemStyle: {
              normal: {
                color: '#c23531',
                shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },

            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx) {
              return Math.random() * 200;
            }
          }
        ]
      };

      var myChart = echarts.init(this.$el);
      myChart.getDom().style.height = this.height
      myChart.getDom().style.width = this.width
      myChart.setOption(option, true);
    }
  }
}
</script>
<style lang="scss" scoped>
canvas {
  height: 100%;
}
</style>
